import Phaser from 'phaser';
import type { CatDefinition } from '@/types';
import { catTextureKey } from '@/game/objects/Cat';

/** Static preview of a cat (idle pose) for cosmetic pickers, using the same
 * AI-illustrated art as in-game -- so a cat looks identical in the picker and in
 * gameplay. `scale` is relative to the art's native CAT_DISPLAY_SIZE-independent
 * source size (512px), so pass a small fraction (e.g. 0.3) for a menu thumbnail. */
export function createCatIcon(scene: Phaser.Scene, x: number, y: number, def: CatDefinition, scale = 0.3): Phaser.GameObjects.Image {
  const image = scene.add.image(x, y, catTextureKey(def.id, 'idle'));
  image.setScale(scale);
  return image;
}
